import React from "react";
import PropTypes from "prop-types";
import Expander from "../../../components/Expander";
import { geneFields, variantFields } from "./helpers";
import ClinicalEvidencesTableColumns from "./ClinicalEvidenceTableColumns";

const ClinicalEvidencesTableRows = ({ result, isGene }) => {
  const columnsNumber = isGene ? geneFields.length + 1 : variantFields.length;
  const fields = isGene ? geneFields : variantFields;

  return (
    <Expander showMore="10" component="tbody" columns={columnsNumber}>
      {result.map((item, i) => {
        return (
          <tr key={`row${i}`}>
            {fields.map((field) => {
              return (
                <td key={field.key}>
                  <ClinicalEvidencesTableColumns
                    item={item}
                    label={field.key}
                    isGene={isGene}
                  />
                </td>
              );
            })}
          </tr>
        );
      })}
    </Expander>
  );
};

ClinicalEvidencesTableRows.propTypes = {
  result: PropTypes.arrayOf(PropTypes.shape({})),
  isGene: PropTypes.bool,
};

ClinicalEvidencesTableRows.defaultProps = {
  result: null,
  isGene: false,
};

export default ClinicalEvidencesTableRows;
